var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 14.666H14.6673",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9668 14.6675L2.00013 6.64747C2.00013 6.24081 2.19346 5.85417 2.51346 5.60084L7.18013 1.9675C7.66013 1.59417 8.33346 1.59417 8.82013 1.9675L13.4868 5.59417C13.8135 5.8475 14.0001 6.23414 14.0001 6.64747V14.6675",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66732 11.334H7.33398C6.78065 11.334 6.33398 11.7807 6.33398 12.334V14.6673H9.66732V12.334C9.66732 11.7807 9.22065 11.334 8.66732 11.334Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 9.16732H5.00065C4.63398 9.16732 4.33398 8.86732 4.33398 8.50065V7.50065C4.33398 7.13398 4.63398 6.83398 5.00065 6.83398H6.33398C6.70065 6.83398 7.00065 7.13398 7.00065 7.50065V8.50065C7.00065 8.86732 6.70065 9.16732 6.33398 9.16732Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.16732H9.66667C9.3 9.16732 9 8.86732 9 8.50065V7.50065C9 7.13398 9.3 6.83398 9.66667 6.83398H11C11.3667 6.83398 11.6667 7.13398 11.6667 7.50065V8.50065C11.6667 8.86732 11.3667 9.16732 11 9.16732Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6662 4.66602L12.6462 2.66602H9.71289",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.1c7697e19948e45699f3b4a8b015fa6c.svg";
export { ForwardRef as ReactComponent };